"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnSchemaToAitoSchema = exports.isInferredFile = exports.isInferredColumn = exports.isInferredColumnType = exports.isColumnType = void 0;
const validation_1 = require("../../validator/validation");
const aito_1 = require("../aito");
exports.isColumnType = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({ name: validation_1.isString, isRequired: validation_1.isBoolean, type: (0, validation_1.isLiteral)('int') }), (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    isRequired: validation_1.isBoolean,
    type: (0, validation_1.isLiteral)('long'),
}), (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    isRequired: validation_1.isBoolean,
    type: (0, validation_1.isLiteral)('decimal'),
}), (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    isRequired: validation_1.isBoolean,
    type: (0, validation_1.isLiteral)('string'),
    null: validation_1.isString.or(validation_1.isUndefined),
}), (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    isRequired: validation_1.isBoolean,
    type: (0, validation_1.isLiteral)('text'),
    null: validation_1.isString.or(validation_1.isUndefined),
    analyzer: aito_1.isAnalyzer,
}), (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    isRequired: validation_1.isBoolean,
    type: (0, validation_1.isLiteral)('boolean'),
    true: validation_1.isString,
    false: validation_1.isString,
}));
const isInferredScalar = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('int', 'long', 'decimal', 'string', 'boolean'),
});
const isInferredText = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('text'),
    analyzer: aito_1.isAnalyzer,
});
exports.isInferredColumnType = (0, validation_1.isSomeOf)(isInferredScalar, isInferredText);
exports.isInferredColumn = (0, validation_1.isObjectOf)({
    samples: (0, validation_1.isArrayOf)(validation_1.isString),
    formats: (0, validation_1.isMapOf)(validation_1.isNumber),
    schema: (0, validation_1.isArrayOf)(exports.isInferredColumnType),
});
exports.isInferredFile = (0, validation_1.isObjectOf)({
    rowCount: validation_1.isNumber,
    header: (0, validation_1.isSomeOf)(validation_1.isNull, (0, validation_1.isArrayOf)(validation_1.isString)),
    exampleRows: (0, validation_1.isArrayOf)((0, validation_1.isArrayOf)(validation_1.isString)),
    columns: (0, validation_1.isArrayOf)(exports.isInferredColumn),
});
const columnSchemaToAitoSchema = (columnSchema, includeColumns) => {
    const result = {
        type: 'table',
        columns: {},
    };
    const columns = result.columns || {};
    columnSchema.forEach((column, i) => {
        if (includeColumns.includes(i)) {
            const col = {};
            col.nullable = !column.isRequired;
            switch (column.type) {
                case 'boolean':
                    col.type = 'Boolean';
                    break;
                case 'decimal':
                    col.type = 'Decimal';
                    break;
                case 'int':
                    col.type = 'Int';
                    break;
                case 'long':
                    col.type = 'Long';
                    break;
                case 'string':
                    col.type = 'String';
                    break;
                case 'text':
                    col.type = 'Text';
                    col.analyzer = column.analyzer;
                    break;
            }
            columns[column.name] = col;
        }
    });
    return result;
};
exports.columnSchemaToAitoSchema = columnSchemaToAitoSchema;
//# sourceMappingURL=csvupload.js.map